<template>
   <div>
    <button>
       <router-link :to="{ name: 'bank-transaction-details'}" class="btn dealers_btn ">
        {{$t('text.clickButtons.details')}}
       </router-link>
</button>
   </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
      
  },
  methods: {
      
  },
};
</script>